"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAnalyticsSignalEventListener = void 0;
var AddToBasketEvent = _interopRequireWildcard(require("@ori-events/add-to-basket"));
var ProductClickEvent = _interopRequireWildcard(require("@ori-events/product-click"));
var _globalApiClientReact = require("@ori/global-api-client-react");
var _presentationHooks = require("@ori/presentation-hooks");
var _react = require("react");
var _constants = require("./constants");
var _events = require("./events");
var _utils = require("./utils");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
/**
 * Hook for listening to specific events and sending signals to the global API.
 *
 * @param enabled
 * @param globalApiUrl
 * @param tenant
 * @param token
 * @param language
 * @param customerId
 */
const useAnalyticsSignalEventListener = ({
  enabled,
  globalApiUrl,
  tenant,
  token,
  language,
  customerId,
  ignoredAddToBasketPlacements: ignoredAddToBasketSources = _constants.DEFAULT_IGNORED_ADD_TO_BASKET_PLACEMENTS
}) => {
  const query = (0, _utils.getSearchResultsQuery)();
  const globalApiClient = (0, _react.useMemo)(() => new _globalApiClientReact.ApiClient({
    baseUrl: globalApiUrl,
    token,
    tenant,
    language
  }), [globalApiUrl, token, tenant, language]);

  // Click on product box link or image not quickBuy
  const productClickHandler = (0, _react.useCallback)(event => (0, _events.productBoxClick)({
    event,
    globalApiClient,
    language,
    customerId,
    query
  }), [customerId, globalApiClient, language, query]);

  // Handler for adding product to basket from all sources (buyButton, quickBuy) except for ignored sources
  const addToBasketHandler = (0, _react.useCallback)(event => {
    const {
      detail
    } = event;
    if (detail.placement != null && ignoredAddToBasketSources.includes(detail.placement)) {
      return;
    }
    (0, _events.addToBasket)({
      event,
      globalApiClient,
      language,
      customerId,
      query
    });
  }, [customerId, globalApiClient, ignoredAddToBasketSources, language, query]);
  const events = (0, _react.useMemo)(() => {
    if (enabled) {
      return [{
        name: ProductClickEvent.Name,
        listener: productClickHandler
      }, {
        name: AddToBasketEvent.Name,
        listener: addToBasketHandler
      }];
    }
    return [];
  }, [addToBasketHandler, enabled, productClickHandler]);
  (0, _presentationHooks.useGlobalEvents)(events);
};
exports.useAnalyticsSignalEventListener = useAnalyticsSignalEventListener;
